<template>
    <Head title="作品列表-批图网"></Head>
    <div class="page page-work-index">

        <div class="banner" :style="{
            backgroundImage: 'url('+ShowBanner+')',
        }"></div>

        <div class="flex flex-col content">
            <div class="filter-container">
                <DropDownCategory :parentCategory="{id: null}"
                                  :categoryList="categoryList">
                    <template #first-level-right-content>
                        <Select v-model:value="filterData.format"
                                :options="formatTypeMap.map(o=>({label:o.name, value: o.value}))"
                                class="selector selector-format"
                                placeholder="文件格式">
                        </Select>
                        <Select v-model:value="filterData.order_by"
                                :options="sortTypeMap.map(o=>({label:o.name, value: o.type}))"
                                class="selector selector-sort"
                                placeholder="排序方式">
                        </Select>
                    </template>
                </DropDownCategory>
            </div>


            <div class="work-list">
                <WorksArea :on-work-load-page="onWorkLoadPage"
                           :default-list="list.data"
                           :load-more-url="loadMoreUrl"
                           v-model:page="page"
                           :default-page="2">
                    <template #no-data>
                        <div class="flex items-center">
                            <img :src="WorkEmpty">
                            <div class="empty-text">暂时没有该分类的作品</div>
                        </div>
                    </template>
                </WorksArea>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import {Head, usePage} from "@inertiajs/vue3";
import {provide, ref, toRaw, watch, onMounted, nextTick, onUnmounted, inject, computed} from "vue";
import {Input, Button, Spin, Select} from "ant-design-vue"
import DropDownCategory from "@/Components/Common/DropDownCategory.vue";
import Link from '@/Components/Link.vue'
import UserPopover from "@/Components/Common/UserPopover.vue";
import _, {debounce} from "lodash";
import {replaceQuery, parseQuery} from "@/utils/url";
import Pagination from "@/Components/Common/Pagination.vue"
import {router} from "@inertiajs/vue3";
import Avatar from "@/Components/Avatar.vue";
import {route} from "@/utils/common";
import dayjs from "dayjs";
import ShowBanner from "@/../images/show-banner.jpg";
import WorksArea from "@/Components/Work/WorksArea.vue";
import http from "@/utils/http";
import WorkEmpty from "@/../images/work-empty.png"
import {useStore} from "@/utils/store";

const filterData = ref({
    category_id: null,
    tag_id: null,
    order_by: null,
    format: null,
    search: '',
})

const loading = ref(false)
const page = ref(1)

const search = () => {
    loading.value = true
    router.visit(replaceQuery(window.location.href, {
        ...filterData.value,
        page: null,
    }), {
        only: ['categoryList', 'list'],
        replace: true,
        preserveScroll: true,
    })
}

const {
    categoryList,
    sortTypeMap,
    list,
    formatTypeMap
} = defineProps<{
    categoryList: any[],
    sortTypeMap: any[],
    formatTypeMap: any[],
    list: any,
}>()

const changeFilterData = _.debounce((key, value) => {
    filterData.value[key] = value
})

const onWorkLoadPage = async (page: number) => {
    const res = await http.get(route('work.index'), {
        params: {
            ...filterData.value,
            page,
        }
    })
    return res.data.list.data
}

const loadMoreUrl = computed(()=>{
    return replaceQuery(route('work.index'), {
        ...filterData.value,
        page: page.value+1,
    })
})

provide('changeFilterCategoryId', (category_id) => {
    changeFilterData('category_id', category_id)
})

const changeHeaderData = inject<Function>('changeHeaderData')

const handleQuery = () => {
    const query = parseQuery(window.location.href)
    for (const k in filterData.value) {
        if (query[k]) {
            filterData.value[k] = query[k]
        }
    }

    if (query.search !== undefined) {
        filterData.value.search = query.search
        changeHeaderData('search', query.search)

        nextTick(() => {
            const store = useStore()

            const workSearchHistoryList = store.localState.workSearchHistory || []
            workSearchHistoryList.unshift(query.search)
            store.localState.workSearchHistory = _.uniq(workSearchHistoryList.slice(0, 10))
        })
    }
}

onMounted(() => {
    handleQuery()

    watch([
        () => filterData.value.category_id,
        () => filterData.value.tag_id,
        () => filterData.value.order_by,
        () => filterData.value.format,
    ], () => {
        debounce(() => {
            search()
        }, 500)()
    })
})

</script>

<style scoped lang="less">
.page-work-index {

    .banner {
        height: 250px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    .content {

        .filter-container {
            padding: 0 136px;
            margin-top: 35px;

            :deep(.selector) {
                min-width: 100px;

                & + .selector {
                    margin-left: 10px;
                }

                &.ant-select-focused {
                    .ant-select-selector {
                        box-shadow: none;
                    }
                }

                .ant-select-selector {
                    background: #F6F6F6;
                    border: none;
                }
            }
        }

        .work-list {
            margin-top: 40px;
            padding: 0 50px;

            :deep(.work-container) {
                padding: 0;
            }

            .empty-text {
                color: #cccccc;
                font-size: 14px;
                margin-left: 16px;
            }
        }
    }

}
</style>
